/**
 * Navigates the agent to the Mira surface on MyeXp, in the same tab —
 * matches this app's existing same-tab-navigation convention
 * (`window.location.href = ...` in App.tsx / authProvider.tsx), never a new
 * tab. Used by all three migration-experience states: the banner CTA, the
 * modal CTA, and the interstitial's automatic + manual fallback redirect.
 */
export function redirectToMiraOnMyExp(url: string | undefined): void {
  const trimmed = url?.trim();
  if (!trimmed) return;
  window.location.href = trimmed;
}
